import React from 'react'
import styled from 'styled-components'

interface IThumb {
  vertical: boolean
}

const SVG = styled.svg``

export const SliderThumb = ({ vertical }: IThumb) => (
  <SVG
    height={vertical ? '80px' : '120px'}
    width={vertical ? '80px' : '120px'}
    viewBox='0 0 80 80'
    version='1.1'
  >
    <g>
      <path
        style={{ fill: '#FFFFFF' }}
        d='M40,15c-13.8,0-25,11.2-25,25s11.2,25,25,25s25-11.2,25-25S53.8,15,40,15z M40,52
        c-6.6,0-12-5.4-12-12c0-6.6,5.4-12,12-12s12,5.4,12,12C52,46.6,46.6,52,40,52z'
      />
    </g>
    <g>
      <path
        style={{ opacity: 0.3, fill: '#FFFFFF' }}
        d='M40,0C17.9,0,0,17.9,0,40c0,22.1,17.9,40,40,40s40-17.9,40-40C80,17.9,62.1,0,40,0z
         M40,47c-3.9,0-7-3.1-7-7c0-3.9,3.1-7,7-7s7,3.1,7,7C47,43.9,43.9,47,40,47z'
      />
    </g>
  </SVG>
)
